import { Application } from "@hotwired/stimulus"
import ScrollProgress from "@stimulus-components/scroll-progress"
import CustomPopover from "./popover_controller"
import ScrollTo from '@stimulus-components/scroll-to'
import RailsNestedForm from '@stimulus-components/rails-nested-form'
import ImageUploader from "./image_uploader_controller"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus   = application

application.register('scroll-progress', ScrollProgress)
application.register('popover', CustomPopover)
application.register('scroll-to', ScrollTo)
application.register('nested-form', RailsNestedForm)
application.register('image-uploader', ImageUploader)

export { application }